import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidate|Eligibilities|';
const sharedProperties: Pick<LocDef, 'feature' | 'portal'> = {
	feature: HubFeature.ExamAuthorization,
	portal: 'SP',
};

type LocNameStart = 'SPEligibilityRevokeDialog';
export type SPEligibilityRevokeDialogLocNames =
	| `${LocNameStart}Title`
	| `${LocNameStart}Content`
	| `${LocNameStart}ButtonRevokeCancel`
	| `${LocNameStart}ButtonRevokeConfirm`;

export const spEligibilityRevokeDialogLocs: LocDefs<SPEligibilityRevokeDialogLocNames> = {
	SPEligibilityRevokeDialogTitle: {
		defaultValue: 'Please confirm',
		description: 'Title for the revoke eligibility confirmation dialog',
		displayPath: `${dpRoot}Title`,
		displayType: 'Title',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Title.RevokeConfirmationTitle',
		...sharedProperties,
	},
	SPEligibilityRevokeDialogContent: {
		defaultValue: 'You would like to revoke this eligibility?',
		description: 'Content for the revoke confirmation dialog',
		displayPath: `${dpRoot}Revoke Confirmation Message`,
		displayType: 'Content',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Content.RevokeConfirmationMessage',
		...sharedProperties,
	},
	SPEligibilityRevokeDialogButtonRevokeCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button on revoke confirmation',
		displayPath: `${dpRoot}Button Revoke Cancel`,
		displayType: 'Button',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Button.RevokeCancel',
		...sharedProperties,
	},
	SPEligibilityRevokeDialogButtonRevokeConfirm: {
		defaultValue: 'Confirm',
		description: 'Confirmation button when revoking an eligibility',
		displayPath: `${dpRoot}Button Revoke Confirm`,
		displayType: 'Button',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Button.RevokeConfirm',
		...sharedProperties,
	},
};

export const LOC_KEYS = MapLocKeys<SPEligibilityRevokeDialogLocNames>(
	spEligibilityRevokeDialogLocs
);
